/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guest_Picker_Children_HintInputs */

const en_guest_picker_children_hint = /** @type {(inputs: Guest_Picker_Children_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ages 2–17`)
};

/**
* | output |
* | --- |
* | "Ages 2–17" |
*
* @param {Guest_Picker_Children_HintInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const guest_picker_children_hint = /** @type {((inputs?: Guest_Picker_Children_HintInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guest_Picker_Children_HintInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_guest_picker_children_hint(inputs)
});